<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#EAECEE" />
    <text
      x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="#37474F"
      font-size="12" font-weight="bold"
    >{{ number }}</text>
  </svg>
</template>




<script>
export default {
  name: 'NumberIcon',
  props: {
    number: {
      type: [String, Number],
      default: 1,
    },
  },
}
</script>
